import { useTranslation } from 'react-i18next';
import { ActiveLink } from '@components/atoms/ActiveLink.tsx';
import {
  getAsbestosImageCaption,
  getDetection,
  getEffectiveRegulation,
  getImages,
} from '@src/asbestos/utils.ts';
import ImageBar from '@components/sample-details/ImagesBar.tsx';
import { StyledMarkdown } from '@components/atoms/StyledMarkdown.tsx';
import { ConfigDto, SampleDetailsDto } from '@src/types/types.ts';
import { AsbestosTargetType } from '@src/asbestos/types.ts';
import { AsbestosStatusMessage } from '@components/sample-details/AsbestosStatusMessage.tsx';

type AnySectionProps = {
  sample: SampleDetailsDto;
  configuration: ConfigDto;
  onInfoTap: () => void;
  targetType: AsbestosTargetType;
};

export const AnySection = ({
  sample,
  configuration,
  onInfoTap,
  targetType,
}: AnySectionProps) => {
  const { t } = useTranslation('component', {
    keyPrefix: 'parameterList',
  });

  if (
    targetType !== AsbestosTargetType.ASB &&
    targetType !== AsbestosTargetType.KMF
  ) {
    return null;
  }

  const regulations = getEffectiveRegulation(sample, targetType);
  const { pmId } = getDetection(targetType, sample);

  return (
    <>
      <AsbestosStatusMessage
        targetAsbestosKind={targetType}
        sample={sample}
        onInfoTap={onInfoTap}
      />
      {regulations !== null && regulations.length > 0 && (
        <StyledMarkdown markdown={regulations[0].explanation} />
      )}
      {pmId && (
        <ActiveLink onTap={onInfoTap}>
          <span className="text-ivarioBlue">{t('moreInfoOnParam')}</span>
        </ActiveLink>
      )}
      {getImages(sample, targetType) && (
        <ImageBar
          className={'mt-4'}
          images={getImages(sample, targetType).map((image) => ({
            image,
            caption: getAsbestosImageCaption(
              image.url,
              configuration,
              targetType,
            ),
          }))}
        />
      )}
    </>
  );
};
